<app-encumbrance-institution-card
	[showDischargeFields]="showDischargeFields"
	[finInstitution]="_mortgagee?.financialInstitution"
	[mortgageeType]="_mortgagee?.mortgageeType"
	(editBranch)="editBranch($event)"
	(removeBranch)="removeBranch()"
	(setBranch)="setBranch($event)"
	(createBranch)="createBranch($event)"
	(editInstitution)="editInstitution($event)"
	(selectInstitution)="selectInstitution($event)"
	(removeInstitution)="removeInstitution()"
	(createInstitution)="createInstitution($event)"
	[pushChangesToGlobalData]="pushChangesToGlobalData"
></app-encumbrance-institution-card>
<div class="flex justify-between mt-5" *ngIf="showCorrespondence">
	<h4>Correspondence</h4>
	<app-radio-group
		header
		type="compact"
		[items]="correspondenceOptions"
		[ngModel]="_mortgagee?.correspondenceType"
		(ngModelChange)="setCorrespondenceType($event)"
	></app-radio-group>
</div>

<div class="mt-5" *ngIf="showCorrespondence">
	<app-solicitor
		*ngIf="_mortgagee?.correspondenceType === correspondenceTypes.SOLICITOR"
		[solicitor]="_mortgagee?.solicitor"
		(onUpdate)="onSolicitorUpdate($event)"
	></app-solicitor>
</div>

<div
	class="flex"
	*ngIf="
		showCorrespondence &&
		_mortgagee?.correspondenceType === correspondenceTypes.MORTGAGEE
	"
	[@openClose]
>
	<app-dropdown
		class="mr-2"
		[itemGroups]="[{ items: attentionOptions }]"
		label="Attention type"
		(onSelect)="setAttentionType($event)"
		[ngModel]="attentionType"
	></app-dropdown>
	<app-input
		class="ml-2"
		label="Attention"
		[ngModel]="_mortgagee?.correspondence?.attention"
		(ngModelChange)="setAttention($event)"
	></app-input>
</div>

<app-container
	type="dark"
	title="Attention Details"
	class="mt-5"
	*ngIf="
		showCorrespondence &&
		_mortgagee?.correspondenceType === correspondenceTypes.MORTGAGEE &&
		_mortgagee?.correspondence?.attentionType === attentionTypes.CONTACT
	"
	[@openClose]
>
	<div class="flex">
		<div class="w-20">
			<app-dropdown
				label="Prefix"
				[itemGroups]="[{ items: titleOptions }]"
				[ngModel]="_mortgagee?.correspondence?.prefix"
				(onSelect)="setPrefix($event)"
			></app-dropdown>
		</div>
		<app-input
			label="First name"
			class="mx-2"
			[ngModel]="_mortgagee?.correspondence?.firstName"
			(debounce)="setFirstName($event)"
		></app-input>
		<app-input
			label="Last name"
			[ngModel]="_mortgagee?.correspondence?.lastName"
			(debounce)="setLastName($event)"
		></app-input>
	</div>
	<div class="flex justify-start mb-5">
		<app-radio-group
			type="compact"
			label="Gender"
			[items]="genderOptions"
			[ngModel]="_mortgagee?.correspondence?.gender"
			(ngModelChange)="setGender($event)"
		></app-radio-group>
	</div>

	<div type="dark">
		<div class="flex justify-between items-center">
			<h4>Contact details</h4>
			<app-checkbox
				header
				type="clear"
				class="text-sm"
				[@fade]
				[ngModel]="_mortgagee?.correspondence?.sameAsInstitution"
				(ngModelChange)="setSameAsInstitution($event)"
				>Same as institution</app-checkbox
			>
		</div>

		<div *ngIf="!_mortgagee?.correspondence?.sameAsInstitution" [@openClose]>
			<div class="flex">
				<app-input
					label="Work phone"
					class="mr-2"
					[ngModel]="_mortgagee?.correspondence?.workPhone"
					(debounce)="setWorkPhone($event)"
				></app-input>
				<app-input
					label="Cell phone"
					class="ml-2"
					[ngModel]="_mortgagee?.correspondence?.phone"
					(debounce)="setPhone($event)"
				></app-input>
			</div>
			<div class="flex mt-3">
				<app-input
					label="Fax"
					class="mr-2"
					[ngModel]="_mortgagee?.correspondence?.fax"
					(debounce)="setFax($event)"
				></app-input>
				<app-input
					label="Email"
					class="ml-2"
					[ngModel]="_mortgagee?.correspondence?.email"
					(debounce)="setEmail($event)"
				></app-input>
			</div>
		</div>
	</div>
</app-container>
